module.exports = __webpack_public_path__ + "img/avatar1.322d5f86.jpg";